import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mailgun = defineConnector({
  identifier: "mailgun",
  name: "Mailgun",
  tagLine: "Transactional email API",
  logo,
  protocol: "http",
  tags: ["communication", "engineering"],
  defaultUrlPattern: () => "https://api(\\.eu)?\\.mailgun\\.net/.*",
  auth: (app) =>
    basicAuth({
      username: "api",
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Mailgun](https://app.mailgun.com/settings/api_security) and copy your private API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Mailgun API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.mailgun.net/v3/domains",
  },
});
